module.exports = __webpack_public_path__ + "static/media/undraw_collecting_fjjl.97d5c207.png";